import { useQuery } from 'react-query';
import { getCartByMemberId } from '@general/api/cartAPI';
import { mapApiCartToProps } from '@general/transforms/cart.transform';

const useCartFromAPI = ({ viewerId }) => {
    // same hook for both logged in and logged out? existing vs new?

    const { data, ...rest } = useQuery(
        `cart-${viewerId}`,
        async () => {
            const cart = await getCartByMemberId({ memberId: viewerId });
            return mapApiCartToProps(cart);
        },
        {
            enabled: !!viewerId,
            staleTime: Infinity,
        }
    );

    return { cart: data, itemCount: data?._calculated?.itemCount, ...rest };
};

export default useCartFromAPI;
